import React, {PureComponent} from "react"
import styled from "styled-components"

import {DEALS, RECOGNITION, MEDICAL} from "@irati/permissions/constants/products"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {MobilePerksLogo, MobileRecognitionLogo, MobileMedicalLogo} from "@irati/ui/src/Logos"
import Flex from "@irati/ui/src/Flex"
import {Tooltip} from "@irati/ui/src/Tooltip"
import {Permissions, TeamPermissions} from "@irati/types"
import {Body} from "@irati/ui/src/Typography"

interface LogoWrapperProps {
  disabled: boolean
}

interface Product {
  label: string,
  value: string
}

const LogoWrapper = styled(Flex)<LogoWrapperProps>`
  img {
    height: 36px;
    width: 36px;
    ${({disabled}) => disabled && `
      opacity: 0.3;
      filter: grayscale(1);
    `}
  }
`

interface Props extends InjectIntl {
  permissionsForTeam: TeamPermissions,
  permissionsForTenant: Permissions
}

class Products extends PureComponent<Props> {
  isProductEnabled = (product: Product) => {
    const {permissionsForTeam, permissionsForTenant} = this.props
    if (!permissionsForTeam) {
      return permissionsForTenant[product.value]?.enabled
    }

    return (permissionsForTenant && permissionsForTenant[product.value]?.enabled)
    || permissionsForTeam[product.value]?.enabled
  }

  getPackageName = () => {
    const {permissionsForTeam} = this.props
    if(permissionsForTeam && permissionsForTeam.deals?.package) {
      return `${permissionsForTeam.deals?.package?.name}`
    }
    return null
  }

  getLogo = (value: string) => {
    switch (value) {
      case RECOGNITION:
        return <MobileRecognitionLogo />
      case MEDICAL:
        return <MobileMedicalLogo />
      case DEALS:
      default:
        return <MobilePerksLogo />
    }
  }

  render() {
    const {formatMessage} = this.props
    const products = [
      {label: formatMessage({id: "admin.components.products.deals"}), value: DEALS},
      {label: formatMessage({id: "admin.components.products.recognition"}), value: RECOGNITION},
      {label: formatMessage({id: "admin.components.products.medical"}), value: MEDICAL}
    ]

    return (
      <Flex direction="column">
        {products.map((product: Product) => {
          const isProductEnabled = this.isProductEnabled(product)
          return (
            <Flex alignItems="center" key={product.value} direction="row">
              <Tooltip tooltipChildren={product.label} placement="bottom">
                <LogoWrapper alignItems="center" disabled={!isProductEnabled}>
                  {this.getLogo(product.value)}
                  <Body>
                    {product.label}
                    {isProductEnabled && product.value === DEALS && this.getPackageName()}
                  </Body>
                </LogoWrapper>
              </Tooltip>
            </Flex>
          )
        })}
      </Flex>
    )
  }
}

export default injectIntl(Products)
